import './Admitcardfloatcomponent.css'
let Admitcardfloatcomponent=(props)=>{
    
    return(
        <div className='admitcardmaincont'>
            <h1 className='admitcardheading'>Download Admitcard</h1>
            <table style={{width:"100%"}}>
                <caption style={{padding:"10px", backgroundColor:"gainsboro", color:"black", fontSize:"22px"}}>Post Details</caption>
                <thead>
                    <tr>
                        <td>Post Name</td>
                        {
                            props.admitcarddata.jobtitle !=undefined ? <td>{props.admitcarddata.jobtitle}</td> : window.location="/search-jobs.com"
                        }
                        
                    </tr>
                    <tr>
                        <td>Post Notify Date</td>
                        <td>{props.admitcarddata.applicationpostdate}</td>
                    </tr>
                    <tr>
                        <td>Admit Card Avaliable Date</td>
                        <td>{props.admitcarddata.admitcardavailabledate}</td>
                    </tr>
                    <tr>
                        <td colSpan="2">Admit Card Downlaod Link</td>
                    </tr>
                    <tr>
                        <td>Downlaod Admit Card</td>
                        <td>
                            {
                                props.admitcarddata.admitcarddownloadlink !== "na" ? <a href={props.admitcarddata.admitcarddownloadlink}>Downlaod Admit card</a> : "Link Will Active Soon..!!!"
                            }
                         
                        </td>
                    </tr>
                    
                    
                </thead>
            </table>
            
        </div>
    )
}
export default Admitcardfloatcomponent;